import React, { useEffect, useState, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { FiRefreshCw } from "react-icons/fi";
import { useMarketSnapshot } from "../../context/MarketSnapshotContext";
import { nseIndicesOptions } from "../Helper/Helperdata";
import useLivePrices from "../../hooks/useLivePrices";
import { useExport } from "../../hooks/useExport";
import { useIndexSymbols } from "../../context/IndexSymbolContext";
import { InfoTooltip } from "../Helper/InfoToolTip";
import { TOOLTIPS } from "../../helper/tooltilData";
import { FaChevronUp, FaChevronDown } from "react-icons/fa";
import "./SmartMoneyScreener.css";

// const INDICES = [
//   "NIFTY 50",
//   "NIFTY BANK",
//   "NIFTY IT",
//   "NIFTY NEXT 50",
//   "NIFTY MIDCAP 100",
// ];

// const SmartMoneyScreener = () => {
//   const navigate = useNavigate();
//   const [selectedIndex, setSelectedIndex] = useState(
//     () => localStorage.getItem("smartMoneyIndex") || "NIFTY 50",
//   );
//   const [sortKey, setSortKey] = useState("smartMoneyScore");
//   const [sortDir, setSortDir] = useState("desc");

//   const { indexSymbols } = useIndexSymbols();
//   const {
//     loadDashboardIndexMarket,
//     dashboardMarketData,
//     resetDashboardMarketData,
//     dashboardLoading,
//   } = useMarketSnapshot();
//   const { prices: livePrices, subscribeSymbols } = useLivePrices();

//   useEffect(() => {
//     if (!selectedIndex) return;
//     localStorage.setItem("smartMoneyIndex", selectedIndex);
//     const symbols = indexSymbols?.[selectedIndex] || [];
//     if (symbols.length) subscribeSymbols(symbols);
//     loadDashboardIndexMarket({ indexName: selectedIndex });
//   }, [selectedIndex, indexSymbols]);

//   const handleIndexChange = (e) => {
//     resetDashboardMarketData();
//     setSelectedIndex(e.target.value);
//   };

// const handleRefresh = () => {
//   loadDashboardIndexMarket({ indexName: selectedIndex });
// };

//   const allStocks = useMemo(() => {
//     const rows = Object.values(dashboardMarketData || {});
//     return rows
//       .map((item) => {
//         const quote = item?.quote?.data;
//         const live = livePrices[item?.symbol];
//         if (!quote?.ohlc) return null;

//         const open = live?.open || quote.ohlc.open;
//         const high = live?.high || quote.ohlc.high;
//         const low = live?.low || quote.ohlc.low;
//         const close = quote.ohlc.close;
//         const ltp = live?.ltp || quote.last_price;
//         const volume = live?.volume || quote.volume || 0;
//         const avgVolume = item?.avgVolume || item?.avg_volume || 0;
//         const deliveryQty = item?.deliveryQty || item?.delivery_quantity || 0;
//         const tradedQty = item?.tradedQty || item?.traded_quantity || volume;
//         const vwap = item?.intraday?.vwap || item?.vwap || null;

//         if (!open || !ltp) return null;

//         const pctChange = close
//           ? Number((((ltp - close) / close) * 100).toFixed(2))
//           : 0;
//         const dayPriceChange = close ? Number((ltp - close).toFixed(2)) : 0;

//         // Smart Money indicators
//         const deliveryPct =
//           tradedQty > 0
//             ? Number(((deliveryQty / tradedQty) * 100).toFixed(2))
//             : 0;
//         const volumeRatio =
//           avgVolume > 0 ? Number((volume / avgVolume).toFixed(2)) : 0;
//         const priceVsVwap =
//           vwap && vwap > 0
//             ? Number((((ltp - vwap) / vwap) * 100).toFixed(2))
//             : null;

//         // Smart Money Score: combines delivery %, volume spike, and price strength
//         let smartMoneyScore = 0;
//         if (deliveryPct > 50) smartMoneyScore += 30;
//         else if (deliveryPct > 35) smartMoneyScore += 20;
//         else if (deliveryPct > 20) smartMoneyScore += 10;

//         if (volumeRatio > 2) smartMoneyScore += 30;
//         else if (volumeRatio > 1.5) smartMoneyScore += 20;
//         else if (volumeRatio > 1) smartMoneyScore += 10;

//         if (pctChange > 2) smartMoneyScore += 20;
//         else if (pctChange > 0.5) smartMoneyScore += 15;
//         else if (pctChange > 0) smartMoneyScore += 5;

//         if (priceVsVwap !== null && priceVsVwap > 0) smartMoneyScore += 20;
//         else if (priceVsVwap !== null && priceVsVwap > -0.5)
//           smartMoneyScore += 10;

//         const smartMoneySignal =
//           smartMoneyScore >= 70
//             ? "Strong"
//             : smartMoneyScore >= 45
//               ? "Moderate"
//               : "Weak";

//         return {
//           symbol: item.symbol,
//           securityId: item.security_id,
//           open,
//           high,
//           low,
//           close,
//           ltp,
//           volume,
//           avgVolume,
//           pctChange,
//           dayPriceChange,
//           deliveryPct,
//           deliveryQty,
//           volumeRatio,
//           vwap,
//           priceVsVwap,
//           smartMoneyScore,
//           smartMoneySignal,
//         };
//       })
//       .filter(Boolean);
//   }, [dashboardMarketData, livePrices]);

//   const sorted = useMemo(() => {
//     return [...allStocks].sort((a, b) => {
//       const aVal = a[sortKey] ?? 0;
//       const bVal = b[sortKey] ?? 0;
//       if (typeof aVal === "string")
//         return sortDir === "asc"
//           ? aVal.localeCompare(bVal)
//           : bVal.localeCompare(aVal);
//       return sortDir === "asc" ? aVal - bVal : bVal - aVal;
//     });
//   }, [allStocks, sortKey, sortDir]);

//   const handleSort = (key) => {
//     if (sortKey === key) setSortDir(sortDir === "desc" ? "asc" : "desc");
//     else {
//       setSortKey(key);
//       setSortDir("desc");
//     }
//   };

//   const SortTh = ({ label, field, align }) => (
//     <th
//       onClick={() => handleSort(field)}
//       className={align === "left" ? "sm__th-left" : ""}
//     >
//       {label}
//       {sortKey === field && (
//         <span className="sm__sort-arrow">
//           {sortDir === "asc" ? " ↑" : " ↓"}
//         </span>
//       )}
//     </th>
//   );

//   const getSignalClass = (signal) => {
//     if (signal === "Strong") return "sm__signal--strong";
//     if (signal === "Moderate") return "sm__signal--moderate";
//     return "sm__signal--weak";
//   };

//   const hasData =
//     dashboardMarketData && Object.keys(dashboardMarketData).length > 0;

//   console.log("dahsboarddtaa", dashboardMarketData);
//   return (
//     <div className="sm">
//       {/* Header */}
//       <div className="sm__header">
//         <div className="sm__header-left">
//           <div className="sm__title-row">
//             <button className="sm__back" onClick={() => navigate(-1)}>
//               ←
//             </button>
//             <h1 className="sm__title">Smart Money Screener</h1>
//           </div>
//           <p className="sm__sub">
//             Track LTP, volume activity &amp; smart money signals across index
//             stocks
//           </p>
//         </div>
//         <div className="sm__header-right">
//           <select
//             className="sm__index-select"
//             value={selectedIndex}
//             onChange={handleIndexChange}
//           >
//             {INDICES.map((idx) => (
//               <option key={idx} value={idx}>
//                 {idx}
//               </option>
//             ))}
//           </select>
//           <button className="sm__refresh-btn" onClick={handleRefresh}>
//             <FiRefreshCw size={14} />
//           </button>
//         </div>
//       </div>

//       {/* Result count */}
//       <div className="sm__result-bar">
//         <span className="sm__result-count">
//           Showing <b>{sorted.length}</b> stocks in {selectedIndex}
//         </span>
//         <span className="sm__live-indicator">
//           <span className="sm__live-dot" /> Live
//         </span>
//       </div>

//       {/* Table */}
//       {dashboardLoading && !hasData ? (
//         <div className="sm__loading">Loading {selectedIndex} stocks...</div>
//       ) : sorted.length === 0 ? (
//         <div className="sm__empty">
//           <div className="sm__empty-icon">📊</div>
//           <div className="sm__empty-title">No data available</div>
//           <div className="sm__empty-sub">
//             Try selecting a different index or refresh
//           </div>
//         </div>
//       ) : (
//         <div className="sm__table-wrap">
//           <table className="sm__table">
//             <thead>
//               <tr>
//                 <SortTh label="Name" field="symbol" align="left" />
//                 <SortTh label="LTP" field="ltp" />
//                 <SortTh label="Chg %" field="pctChange" />
//                 <SortTh label="Volume" field="volume" />
//                 <SortTh label="Vol Ratio" field="volumeRatio" />
//                 <SortTh label="Del %" field="deliveryPct" />
//                 <SortTh label="VWAP" field="vwap" />
//                 <SortTh label="LTP vs VWAP" field="priceVsVwap" />
//                 <SortTh label="Smart Money" field="smartMoneyScore" />
//               </tr>
//             </thead>
//             <tbody>
//               {sorted.map((stock) => (
//                 <tr
//                   key={stock.symbol}
//                   className="sm__row"
//                   onClick={() =>
//                     navigate(`/stockdetail/${stock.symbol}/${stock.securityId}`)
//                   }
//                 >
//                   <td className="sm__td-name">
//                     <span className="sm__symbol">{stock.symbol}</span>
//                   </td>
//                   <td className="sm__td-num">
//                     ₹
//                     {stock.ltp?.toLocaleString("en-IN", {
//                       minimumFractionDigits: 2,
//                       maximumFractionDigits: 2,
//                     })}
//                   </td>
//                   <td
//                     className={`sm__td-num ${stock.pctChange >= 0 ? "sm__green" : "sm__red"}`}
//                   >
//                     {stock.pctChange > 0 ? "+" : ""}
//                     {stock.pctChange}%
//                   </td>
//                   <td className="sm__td-num">
//                     {stock.volume?.toLocaleString("en-IN")}
//                   </td>
//                   <td
//                     className={`sm__td-num ${stock.volumeRatio >= 1.5 ? "sm__green" : ""}`}
//                   >
//                     {stock.volumeRatio > 0 ? `${stock.volumeRatio}x` : "—"}
//                   </td>
//                   <td
//                     className={`sm__td-num ${stock.deliveryPct >= 40 ? "sm__green" : ""}`}
//                   >
//                     {stock.deliveryPct > 0 ? `${stock.deliveryPct}%` : "—"}
//                   </td>
//                   <td className="sm__td-num">
//                     {stock.vwap
//                       ? `₹${stock.vwap.toLocaleString("en-IN", {
//                           minimumFractionDigits: 2,
//                           maximumFractionDigits: 2,
//                         })}`
//                       : "—"}
//                   </td>
//                   <td
//                     className={`sm__td-num ${
//                       stock.priceVsVwap !== null
//                         ? stock.priceVsVwap >= 0
//                           ? "sm__green"
//                           : "sm__red"
//                         : ""
//                     }`}
//                   >
//                     {stock.priceVsVwap !== null
//                       ? `${stock.priceVsVwap > 0 ? "+" : ""}${stock.priceVsVwap}%`
//                       : "—"}
//                   </td>
//                   <td className="sm__td-num">
//                     <span
//                       className={`sm__signal-badge ${getSignalClass(stock.smartMoneySignal)}`}
//                     >
//                       {stock.smartMoneyScore}
//                     </span>
//                     <span className="sm__signal-label">
//                       {stock.smartMoneySignal}
//                     </span>
//                   </td>
//                 </tr>
//               ))}
//             </tbody>
//           </table>
//         </div>
//       )}

//       {/* Footer */}
//       {sorted.length > 0 && (
//         <div className="sm__footer">
//           <span>
//             Showing {sorted.length} of {allStocks.length} results
//           </span>
//         </div>
//       )}
//     </div>
//   );
// };

// const SmartMoneyScreener = () => {
//   const navigate = useNavigate();
//   const [selectedIndex, setSelectedIndex] = useState(
//     () => localStorage.getItem("smartMoneyIndex") || "NIFTY 50",
//   );
//   const [sortKey, setSortKey] = useState("smartMoneyScore");
//   const [sortDir, setSortDir] = useState("desc");

//   const { indexSymbols } = useIndexSymbols();
//   const {
//     loadDashboardIndexMarket,
//     dashboardMarketData,
//     resetDashboardMarketData,
//     dashboardLoading,
//   } = useMarketSnapshot();
//   const { prices: livePrices, subscribeSymbols } = useLivePrices();

//   useEffect(() => {
//     if (!selectedIndex) return;
//     localStorage.setItem("smartMoneyIndex", selectedIndex);
//     const symbols = indexSymbols?.[selectedIndex] || [];
//     if (symbols.length) subscribeSymbols(symbols);
//     loadDashboardIndexMarket({ indexName: selectedIndex });
//   }, [selectedIndex, indexSymbols]);

//   const handleIndexChange = (e) => {
//     resetDashboardMarketData();
//     setSelectedIndex(e.target.value);
//   };

//   const handleRefresh = () => {
//     loadDashboardIndexMarket({ indexName: selectedIndex });
//   };

//   const allStocks = useMemo(() => {
//     const rows = Object.values(dashboardMarketData || {});
//     return rows
//       .map((item) => {
//         const quote = item?.quote?.data;
//         const live = livePrices[item?.symbol];
//         const sm = item?.smart_money;
//         if (!quote?.ohlc) return null;

//         const open = live?.open || quote.ohlc.open;
//         const high = live?.high || quote.ohlc.high;
//         const low = live?.low || quote.ohlc.low;
//         // LTP & Volume from live feed only
//         const ltp = live?.ltp;
//         const volume = live?.volume || 0;
//         // Close from quote only
//         const close = quote.ohlc.close;
//         const averageVolume20 = item?.average_volume_20 || 0;

//         if (!ltp) return null;

//         const pctChange = close
//           ? Number((((ltp - close) / close) * 100).toFixed(2))
//           : 0;
//         const dayPriceChange = close ? Number((ltp - close).toFixed(2)) : 0;

//         // Relative Volume = current volume / 20-day avg volume
//         const relativeVolume =
//           Number.isFinite(volume) &&
//           Number.isFinite(averageVolume20) &&
//           averageVolume20 > 0
//             ? Number((volume / averageVolume20).toFixed(2))
//             : null;

//         // Smart Money fields from API
//         const smartMoneyScore = sm?.score ?? null;
//         const smartMoneySignal = sm?.signal || sm?.status || "—";
//         const cmfValue = sm?.cmf?.value ?? null;
//         const cmfSignal = sm?.cmf?.signal || "—";
//         const mfiValue = sm?.mfi?.value ?? null;
//         const mfiSignal = sm?.mfi?.signal || "—";
//         const obvSignal = sm?.obv?.signal || "—";
//         const rvolValue = sm?.rvol?.value ?? null;
//         const rvolSignal = sm?.rvol?.signal || "—";
//         const vwapSignal = sm?.vwapSignal || "—";
//         const conclusion = sm?.conclusion || "";

//         return {
//           symbol: item.symbol,
//           securityId: item.security_id,
//           company: item.company || "",
//           open,
//           high,
//           low,
//           close,
//           ltp,
//           volume,
//           averageVolume20,
//           pctChange,
//           dayPriceChange,
//           relativeVolume,
//           smartMoneyScore,
//           smartMoneySignal,
//           cmfValue,
//           cmfSignal,
//           mfiValue,
//           mfiSignal,
//           obvSignal,
//           rvolValue,
//           rvolSignal,
//           vwapSignal,
//           conclusion,
//         };
//       })
//       .filter(Boolean);
//   }, [dashboardMarketData, livePrices]);

//   const sorted = useMemo(() => {
//     return [...allStocks].sort((a, b) => {
//       const aVal = a[sortKey] ?? -Infinity;
//       const bVal = b[sortKey] ?? -Infinity;
//       if (typeof aVal === "string")
//         return sortDir === "asc"
//           ? aVal.localeCompare(bVal)
//           : bVal.localeCompare(aVal);
//       return sortDir === "asc" ? aVal - bVal : bVal - aVal;
//     });
//   }, [allStocks, sortKey, sortDir]);

//   const handleSort = (key) => {
//     if (sortKey === key) setSortDir(sortDir === "desc" ? "asc" : "desc");
//     else {
//       setSortKey(key);
//       setSortDir("desc");
//     }
//   };

//   const SortTh = ({ label, field, align }) => (
//     <th
//       onClick={() => handleSort(field)}
//       className={align === "left" ? "sm__th-left" : ""}
//     >
//       {label}
//       {sortKey === field && (
//         <span className="sm__sort-arrow">
//           {sortDir === "asc" ? " ↑" : " ↓"}
//         </span>
//       )}
//     </th>
//   );

//   const getScoreClass = (score) => {
//     if (score === null) return "";
//     if (score >= 70) return "sm__signal--strong";
//     if (score >= 45) return "sm__signal--moderate";
//     return "sm__signal--weak";
//   };

//   const getSignalTextClass = (signal) => {
//     const s = signal?.toLowerCase();
//     if (
//       s === "bullish" ||
//       s === "accumulation" ||
//       s === "mild accumulation" ||
//       s === "money entering"
//     )
//       return "sm__green";
//     if (
//       s === "bearish" ||
//       s === "distribution" ||
//       s === "money leaving" ||
//       s === "sell"
//     )
//       return "sm__red";
//     return "";
//   };

//   const getRvolClass = (val) => {
//     if (val === null) return "";
//     if (val >= 1.5) return "sm__green";
//     if (val < 0.5) return "sm__red";
//     return "";
//   };

//   const hasData =
//     dashboardMarketData && Object.keys(dashboardMarketData).length > 0;
//   console.log("Dashboard Market Data", dashboardMarketData);

//   return (
//     <div className="sm">
//       {/* Header */}
//       <div className="sm__header">
//         <div className="sm__header-left">
//           <div className="sm__title-row">
//             <button className="sm__back" onClick={() => navigate(-1)}>
//               ←
//             </button>
//             <h1 className="sm__title">Smart Money Screener</h1>
//           </div>
//           <p className="sm__sub">
//             Track LTP, volume activity &amp; smart money signals across index
//             stocks
//           </p>
//         </div>
//         <div className="sm__header-right">
//           <select
//             className="sm__index-select"
//             value={selectedIndex}
//             onChange={handleIndexChange}
//           >
//             {INDICES.map((idx) => (
//               <option key={idx} value={idx}>
//                 {idx}
//               </option>
//             ))}
//           </select>
//           <button className="sm__refresh-btn" onClick={handleRefresh}>
//             <FiRefreshCw size={14} />
//           </button>
//         </div>
//       </div>

//       {/* Result count */}
//       <div className="sm__result-bar">
//         {/* <span className="sm__result-count">
//           Showing <b>{sorted.length}</b> stocks in {selectedIndex}
//         </span> */}
//         <span className="sm__live-indicator">
//           <span className="sm__live-dot" /> Live
//         </span>
//       </div>

//       {/* Table */}
//       {dashboardLoading && !hasData ? (
//         <div className="sm__loading">Loading {selectedIndex} stocks...</div>
//       ) : sorted.length === 0 ? (
//         <div className="sm__empty">
//           <div className="sm__empty-icon">📊</div>
//           <div className="sm__empty-title">No data available</div>
//           <div className="sm__empty-sub">
//             Try selecting a different index or refresh
//           </div>
//         </div>
//       ) : (
//         <div className="sm__table-wrap">
//           <table className="sm__table stock-table">
//             <thead>
//               <tr>
//                 <SortTh label="Name" field="symbol" align="left" />
//                 <SortTh label="LTP" field="ltp" />
//                 <SortTh label="Chg %" field="pctChange" />
//                 <SortTh label="Volume" field="volume" />
//                 <SortTh label="Avg Vol (20d)" field="averageVolume20" />
//                 <SortTh label="Rel Vol" field="relativeVolume" />
//                 <SortTh label="RVOL" field="rvolValue" />
//                 <SortTh label="CMF" field="cmfValue" />
//                 <SortTh label="MFI" field="mfiValue" />
//                 <SortTh label="OBV" field="obvSignal" />
//                 <SortTh label="VWAP" field="vwapSignal" />
//                 <SortTh label="Score" field="smartMoneyScore" />
//                 <SortTh label="Signal" field="smartMoneySignal" />
//               </tr>
//             </thead>
//             <tbody>
//               {sorted.map((stock) => (
//                 <tr
//                   key={stock.symbol}
//                   className="sm__row"
//                   onClick={() =>
//                     navigate(`/stockdetail/${stock.symbol}/${stock.securityId}`)
//                   }
//                 >
//                   {/* Name */}
//                   <td className="sm__td-name">
//                     <span className="sm__symbol">{stock.symbol}</span>
//                   </td>

//                   {/* LTP */}
//                   <td className="sm__td-num">
//                     ₹
//                     {stock.ltp?.toLocaleString("en-IN", {
//                       minimumFractionDigits: 2,
//                       maximumFractionDigits: 2,
//                     })}
//                   </td>

//                   {/* Change % */}
//                   <td
//                     className={`sm__td-num ${stock.pctChange >= 0 ? "sm__green" : "sm__red"}`}
//                   >
//                     {stock.pctChange > 0 ? "+" : ""}
//                     {stock.pctChange}%
//                   </td>

//                   {/* Volume */}
//                   <td className="sm__td-num">
//                     {stock.volume?.toLocaleString("en-IN")}
//                   </td>

//                   {/* Avg Volume 20d */}
//                   <td className="sm__td-num">
//                     {stock.averageVolume20 > 0
//                       ? stock.averageVolume20.toLocaleString("en-IN")
//                       : "—"}
//                   </td>

//                   {/* Relative Volume (volume / avg_vol_20) */}
//                   <td
//                     className={`sm__td-num ${getRvolClass(stock.relativeVolume)}`}
//                   >
//                     {stock.relativeVolume !== null
//                       ? `${stock.relativeVolume}x`
//                       : "—"}
//                   </td>

//                   {/* RVOL from smart_money */}
//                   <td className={`sm__td-num ${getRvolClass(stock.rvolValue)}`}>
//                     {stock.rvolValue !== null ? (
//                       <span>
//                         {stock.rvolValue}x{" "}
//                         {/* <span className="sm__sub-signal">
//                           {stock.rvolSignal}
//                         </span> */}
//                       </span>
//                     ) : (
//                       "—"
//                     )}
//                   </td>

//                   {/* CMF */}
//                   <td
//                     className={`sm__td-num ${getSignalTextClass(stock.cmfSignal)}`}
//                   >
//                     {stock.cmfValue !== null ? (
//                       <span>
//                         {stock.cmfValue.toFixed(4)}{" "}
//                         {/* <span className="sm__sub-signal">
//                           {stock.cmfSignal}
//                         </span> */}
//                       </span>
//                     ) : (
//                       "—"
//                     )}
//                   </td>

//                   {/* MFI */}
//                   <td
//                     className={`sm__td-num ${getSignalTextClass(stock.mfiSignal)}`}
//                   >
//                     {stock.mfiValue !== null ? (
//                       <span>
//                         {stock.mfiValue.toFixed(2)}{" "}
//                         {/* <span className="sm__sub-signal">
//                           {stock.mfiSignal}
//                         </span> */}
//                       </span>
//                     ) : (
//                       "—"
//                     )}
//                   </td>

//                   {/* OBV */}
//                   <td
//                     className={`sm__td-num ${getSignalTextClass(stock.obvSignal)}`}
//                   >
//                     {stock.obvSignal}
//                   </td>

//                   {/* VWAP Signal */}
//                   <td
//                     className={`sm__td-num ${getSignalTextClass(stock.vwapSignal)}`}
//                   >
//                     {stock.vwapSignal}
//                   </td>

//                   {/* Smart Money Score */}
//                   <td className="sm__td-num">
//                     {stock.smartMoneyScore !== null ? (
//                       <span
//                         className={`sm__signal-badge ${getScoreClass(stock.smartMoneyScore)}`}
//                       >
//                         {stock.smartMoneyScore}
//                       </span>
//                     ) : (
//                       "—"
//                     )}
//                   </td>

//                   {/* Smart Money Signal */}
//                   <td className="sm__td-num">
//                     <span
//                       className={`sm__signal-pill ${getSignalTextClass(stock.smartMoneySignal)}`}
//                     >
//                       {stock.smartMoneySignal}
//                     </span>
//                   </td>
//                 </tr>
//               ))}
//             </tbody>
//           </table>
//         </div>
//       )}

//       {/* Footer */}
//       {/* {sorted.length > 0 && (
//         <div className="sm__footer">
//           <span>
//             Showing {sorted.length} of {allStocks.length} results
//           </span>
//         </div>
//       )} */}
//     </div>
//   );
// };

const SmartMoneyScreener = () => {
  const navigate = useNavigate();
  const [selectedIndex, setSelectedIndex] = useState(
    () => localStorage.getItem("smartMoneyIndex") || "NIFTY 50",
  );
  //   const [sortKey, setSortKey] = useState("smartMoneyScore");
  //   const [sortDir, setSortDir] = useState("desc");
  const [sortKey, setSortKey] = useState("symbol");
  const [sortDir, setSortDir] = useState("asc");

  const { exportCSV, exportExcel, exporting } = useExport();
  const { indexSymbols } = useIndexSymbols();
  const {
    loadDashboardIndexMarket,
    dashboardMarketData,
    resetDashboardMarketData,
    dashboardLoading,
  } = useMarketSnapshot();
  const { prices: livePrices, subscribeSymbols } = useLivePrices();

  useEffect(() => {
    if (!selectedIndex) return;
    localStorage.setItem("smartMoneyIndex", selectedIndex);
    // const symbols = indexSymbols?.[selectedIndex] || [];
    let symbols = [];
    if (selectedIndex === "ALL") {
      // union of every index's symbols, deduped
      const set = new Set();
      Object.values(indexSymbols || {}).forEach((list) => {
        (list || []).forEach((s) => s && set.add(s));
      });
      symbols = [...set];
    } else {
      symbols = indexSymbols?.[selectedIndex] || [];
    }
    if (symbols.length) subscribeSymbols(symbols);
    loadDashboardIndexMarket({ indexName: selectedIndex });
  }, [selectedIndex, indexSymbols]);

  const handleIndexChange = (e) => {
    resetDashboardMarketData();
    setSelectedIndex(e.target.value);
  };

  const handleRefresh = () => {
    loadDashboardIndexMarket({ indexName: selectedIndex });
  };
  console.log("Dashboard dtaa", dashboardMarketData);
  const allStocks = useMemo(() => {
    const rows = Object.values(dashboardMarketData || {});
    return rows
      .map((item) => {
        const quote = item?.quote?.data;
        const live = livePrices[item?.symbol];
        const sm = item?.smart_money;
        if (!quote?.ohlc) return null;

        const open = quote.ohlc.open;
        const high = quote.ohlc.high;
        const low = quote.ohlc.low;
        // LTP & Volume from live feed only
        // const ltp = live?.ltp;
        const ltp = live?.ltp ?? quote?.last_price;
        const volume = live?.volume ?? quote?.volume;
        // Close from quote only
        const close = item?.prev_close ?? quote?.ohlc?.close;
        const averageVolume20 = item?.average_volume_20 || 0;
        const macd = item?.macd?.toFixed(2);
        const macdSignal = item?.prediction;

        if (!ltp) return null;

        const pctChange = close
          ? Number((((ltp - close) / close) * 100).toFixed(2))
          : 0;
        const dayPriceChange = close ? Number((ltp - close).toFixed(2)) : 0;

        // Relative Volume = current volume / 20-day avg volume
        // const relativeVolume =
        //   Number.isFinite(volume) &&
        //   Number.isFinite(averageVolume20) &&
        //   averageVolume20 > 0
        //     ? Number((volume / averageVolume20).toFixed(2))
        //     : null;
        const relativeVolume =
          Number.isFinite(volume) &&
          Number.isFinite(averageVolume20) &&
          averageVolume20 > 0
            ? Number((volume / averageVolume20).toFixed(2))
            : null;
        // Smart Money fields from API
        const smartMoneyScore = sm?.score ?? null;
        const smartMoneySignal = sm?.signal || sm?.status || "—";
        const cmfValue = sm?.cmf?.value ?? null;
        const cmfSignal = sm?.cmf?.signal || "—";
        const mfiValue = sm?.mfi?.value ?? null;
        const mfiSignal = sm?.mfi?.signal || "—";
        const obvSignal = sm?.obv?.signal || "—";
        const rvolValue = sm?.rvol?.value ?? null;
        const rvolSignal = sm?.rvol?.signal || "—";
        const vwapSignal = sm?.vwapSignal || "—";
        const conclusion = sm?.conclusion || "";

        return {
          symbol: item.symbol,
          securityId: item.security_id,
          company: item.company || "",
          open,
          high,
          low,
          close,
          ltp,
          volume,
          averageVolume20,
          pctChange,
          dayPriceChange,
          relativeVolume,
          smartMoneyScore,
          smartMoneySignal,
          cmfValue,
          cmfSignal,
          mfiValue,
          mfiSignal,
          obvSignal,
          rvolValue,
          rvolSignal,
          vwapSignal,
          macd,
          macdSignal,
          conclusion,
        };
      })
      .filter(Boolean);
  }, [dashboardMarketData, livePrices]);

  console.log("All stock", allStocks);
  const sorted = useMemo(() => {
    return [...allStocks].sort((a, b) => {
      const aVal = a[sortKey] ?? -Infinity;
      const bVal = b[sortKey] ?? -Infinity;
      if (typeof aVal === "string")
        return sortDir === "asc"
          ? aVal.localeCompare(bVal)
          : bVal.localeCompare(aVal);
      return sortDir === "asc" ? aVal - bVal : bVal - aVal;
    });
  }, [allStocks, sortKey, sortDir]);

  const handleSort = (key) => {
    if (sortKey === key) setSortDir(sortDir === "desc" ? "asc" : "desc");
    else {
      setSortKey(key);
      setSortDir("desc");
    }
  };

  //   const SortTh = ({ label, field, align }) => (
  //     <th
  //       onClick={() => handleSort(field)}
  //       className={align === "left" ? "sm__th-left" : ""}
  //     >
  //       {label}
  //       {sortKey === field && (
  //         <span className="sm__sort-arrow">
  //           {sortDir === "asc" ? " ↑" : " ↓"}
  //         </span>
  //       )}
  //     </th>
  //   );
  //   const SortTh = ({ label, field, align, tooltip }) => (
  //     <th
  //       onClick={() => handleSort(field)}
  //       className={align === "left" ? "sm__th-left" : ""}
  //     >
  //       {label}
  //       {tooltip && <InfoTooltip text={tooltip} />}
  //       {sortKey === field && (
  //         <span className="sm__sort-arrow">
  //           {sortDir === "asc" ? " ↑" : " ↓"}
  //         </span>
  //       )}
  //     </th>
  //   );
  const SortTh = ({ label, field, align, tooltip }) => (
    <th className={align === "left" ? "sm__th-left" : ""}>
      <div className="sm__sort-head">
        {label}
        {tooltip && <InfoTooltip text={tooltip} />}
        <span className="sm__sort-arrows">
          <FaChevronUp
            size={10}
            className={sortKey === field && sortDir === "asc" ? "active" : ""}
            onClick={(e) => {
              e.stopPropagation();
              setSortKey(field);
              setSortDir("asc");
            }}
          />
          <FaChevronDown
            size={10}
            className={sortKey === field && sortDir === "desc" ? "active" : ""}
            onClick={(e) => {
              e.stopPropagation();
              setSortKey(field);
              setSortDir("desc");
            }}
          />
        </span>
      </div>
    </th>
  );
  const getScoreClass = (score) => {
    if (score === null) return "";
    if (score >= 70) return "sm__signal--strong";
    if (score >= 45) return "sm__signal--moderate";
    return "sm__signal--weak";
  };

  // % Change: graduated color by intensity
  const getPctChangeClass = (pct) => {
    if (pct >= 3) return "sm__clr-strong-bull";
    if (pct >= 1) return "sm__clr-bull";
    if (pct > 0) return "sm__clr-mild-bull";
    if (pct === 0) return "sm__clr-neutral";
    if (pct > -1) return "sm__clr-mild-bear";
    if (pct > -3) return "sm__clr-bear";
    return "sm__clr-strong-bear";
  };

  // Relative Volume & RVOL: standard thresholds
  const getRvolClass = (val) => {
    if (val === null || val === undefined) return "sm__clr-neutral";
    if (val >= 2.5) return "sm__clr-rvol-extreme"; // unusual spike
    if (val >= 1.5) return "sm__clr-rvol-high"; // above average
    if (val >= 0.8) return "sm__clr-rvol-normal"; // normal range
    if (val >= 0.5) return "sm__clr-rvol-low"; // below average
    return "sm__clr-rvol-dry"; // very low / dry
  };
  const getRelativeVolumeColor = (value) => {
    const relativeVolume = Number(value);

    if (!Number.isFinite(relativeVolume)) return "#6b7280";

    if (relativeVolume >= 1.5) return "#16a34a"; // green
    if (relativeVolume < 0.5) return "#9ca3af"; // grey

    return "#d97706"; // normal/orange
  };
  const getSignalTextClass = (signal) => {
    const s = signal?.toLowerCase();
    if (
      s === "bullish" ||
      s === "accumulation" ||
      s === "money entering" ||
      s === "high volume"
    )
      return "sm__clr-bull";
    if (s === "mild accumulation") return "sm__clr-mild-bull";
    if (
      s === "bearish" ||
      s === "distribution" ||
      s === "money leaving" ||
      s === "sell"
    )
      return "sm__clr-bear";
    if (s === "low volume") return "sm__clr-rvol-low";
    return "sm__clr-neutral";
  };

  const EXPORT_COLUMNS = [
    { header: "Symbol", key: "symbol", width: 15 },
    { header: "Company", key: "company", width: 20 },
    { header: "LTP", key: "ltp", width: 12 },
    { header: "Chg %", key: "pctChange", width: 10 },
    { header: "Volume", key: "volume", width: 14 },
    { header: "Avg Vol (20d)", key: "averageVolume20", width: 16 },
    { header: "Rel Vol (20d)", key: "relativeVolume", width: 14 },
    { header: "RVOL", key: "rvolValue", width: 10 },
    { header: "CMF", key: "cmfValue", width: 12 },
    { header: "MFI", key: "mfiValue", width: 12 },
    { header: "OBV", key: "obvSignal", width: 12 },
    { header: "MACD", key: "macd", width: 12 },
    { header: "MACD Signal", key: "macdSignal", width: 14 },
    { header: "Score", key: "smartMoneyScore", width: 10 },
    { header: "Smart Money Signal", key: "smartMoneySignal", width: 18 },
  ];

  const buildExportRows = () =>
    sorted.map((s) => ({
      symbol: s.symbol,
      company: s.company || "",
      ltp: s.ltp ?? "",
      pctChange: s.pctChange ?? "",
      volume: s.volume ?? "",
      averageVolume20: s.averageVolume20 > 0 ? s.averageVolume20 : "",
      relativeVolume: s.relativeVolume ?? "",
      rvolValue: s.rvolValue ?? "",
      cmfValue: s.cmfValue ?? "",
      mfiValue: s.mfiValue ?? "",
      obvSignal: s.obvSignal || "",
      macd: s.macd ?? "",
      macdSignal: s.macdSignal || "",
      smartMoneyScore: s.smartMoneyScore ?? "",
      smartMoneySignal: s.smartMoneySignal || "",
    }));

  const handleDownloadCSV = () =>
    exportCSV({
      rows: buildExportRows(),
      columns: EXPORT_COLUMNS,
      filename: `${selectedIndex}_smart_money`,
      sheetName: selectedIndex,
    });

  const handleDownloadExcel = () =>
    exportExcel({
      rows: buildExportRows(),
      columns: EXPORT_COLUMNS,
      filename: `${selectedIndex}_smart_money`,
      sheetName: selectedIndex,
    });

  //   const hasData = dashboardMarketData && !dashboardLoading;
  console.log("DashboardData", dashboardMarketData);
  console.log("Sorted", sorted);

  return (
    <div className="sm">
      {/* Header */}
      <div className="sm__header">
        <div className="sm__header-left">
          <div className="sm__title-row">
            <button className="sm__back" onClick={() => navigate(-1)}>
              ←
            </button>
            <h1 className="sm__title">Smart Money Screener</h1>
          </div>
          <p className="sm__sub">
            Track LTP, volume activity &amp; smart money signals across index
            stocks
          </p>
        </div>
        <div className="sm__header-right">
          <select
            className="sm__index-select"
            value={selectedIndex}
            onChange={handleIndexChange}
          >
            <option value="ALL">All Stocks</option>

            {nseIndicesOptions?.map((idx) => (
              <option key={idx} value={idx}>
                {idx}
              </option>
            ))}
          </select>
          <button className="sm__refresh-btn" onClick={handleRefresh}>
            <FiRefreshCw size={14} />
          </button>
          <button
            className="sm__refresh-btn"
            onClick={handleDownloadCSV}
            disabled={exporting}
          >
            {exporting ? "…" : "CSV ⬇"}
          </button>
          <button
            className="sm__refresh-btn"
            onClick={handleDownloadExcel}
            disabled={exporting}
          >
            {exporting ? "…" : "Excel ⬇"}
          </button>
        </div>
      </div>

      {/* Result count */}
      <div className="sm__result-bar">
        {/* <span className="sm__result-count">
          Showing <b>{sorted.length}</b> stocks in {selectedIndex}
        </span> */}
        <span className="sm__live-indicator">
          <span className="sm__live-dot" /> Live
        </span>
      </div>

      {/* Table */}
      {/* {dashboardLoading ? (
        <div className="sm__loading">Loading {selectedIndex} stocks...</div>
      ) : sorted.length === 0 ? (
        <div className="sm__empty">
          <div className="sm__empty-icon">📊</div>
          <div className="sm__empty-title">No data available</div>
          <div className="sm__empty-sub">
            Try selecting a different index or refresh
          </div>
        </div>
      ) : ( */}
      <div className="sm__table-wrap">
        <table className="sm__table option-table">
          {/* <thead>
            <tr>
              <SortTh label="Name" field="symbol" align="left" />
              <SortTh label="LTP" field="ltp" />
              <SortTh label="Chg %" field="pctChange" />
              <SortTh label="Volume" field="volume" />
              <SortTh label="Avg Vol (20d)" field="averageVolume20" />
              <SortTh label="Rel Vol (20d)" field="relativeVolume" />
              <SortTh label="RVOL" field="rvolValue" />
              <SortTh label="CMF" field="cmfValue" InfoTooltip={InfoTooltip}/>
              <SortTh label="MFI" field="mfiValue" />
              <SortTh label="OBV" field="obvSignal" />
              <SortTh label="MACD" field="macd" align="left" />
              <SortTh label="MACD Signal" field="vwapSignal" />
              <SortTh label="Score" field="smartMoneyScore" />
              <SortTh label="Smart Money Signal" field="smartMoneySignal" />
            </tr>
          </thead> */}
          <thead>
            <tr>
              <SortTh label="Name" field="symbol" align="left" />
              <SortTh label="LTP" field="ltp" tooltip={TOOLTIPS?.ltp} />
              <SortTh
                label="Chg %"
                field="pctChange"
                tooltip={TOOLTIPS?.percentChange}
              />
              <SortTh
                label="Volume"
                field="volume"
                tooltip={TOOLTIPS?.volume}
              />
              <SortTh
                label="Avg Vol (20d)"
                field="averageVolume20"
                tooltip={TOOLTIPS?.avgVolume}
              />
              <SortTh
                label="Rel Vol (20d)"
                field="relativeVolume"
                tooltip={TOOLTIPS?.relativeVolume}
              />
              <SortTh label="RVOL" field="rvolValue" tooltip={TOOLTIPS?.rvol} />
              <SortTh label="CMF" field="cmfValue" tooltip={TOOLTIPS?.cmf} />
              <SortTh label="MFI" field="mfiValue" tooltip={TOOLTIPS?.mfi} />
              <SortTh label="OBV" field="obvSignal" tooltip={TOOLTIPS?.obv} />
              <SortTh
                label="MACD"
                field="macd"
                align="left"
                tooltip={TOOLTIPS?.macd}
              />
              <SortTh
                label="MACD Signal"
                field="macdSignal"
                tooltip={TOOLTIPS?.rsiMacdSignal}
              />
              <SortTh
                label="Score"
                field="smartMoneyScore"
                tooltip={TOOLTIPS?.smartMoneyScore}
              />
              <SortTh
                label="Smart Money Signal"
                field="smartMoneySignal"
                tooltip={TOOLTIPS?.smartMoney}
              />
            </tr>
          </thead>
          <tbody>
            {sorted.map((stock) => (
              <tr
                key={stock.symbol}
                className="sm__row"
                onClick={() =>
                  navigate(`/stockdetail/${stock.symbol}/${stock.securityId}`)
                }
              >
                {/* Name */}
                <td className="sm__td-name">
                  <span className="sm__symbol">{stock.symbol}</span>
                </td>

                {/* LTP */}
                <td className="sm__td-num">
                  ₹
                  {stock.ltp?.toLocaleString("en-IN", {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  })}
                </td>

                {/* Change % */}
                <td
                  className={`sm__td-num ${getPctChangeClass(stock.pctChange)}`}
                  style={{
                    color:
                      stock?.pctChange > 0
                        ? "#249966"
                        : stock?.pctChange < 0
                          ? "#f87171"
                          : "#64748b",
                  }}
                >
                  {stock.pctChange > 0 ? "+" : ""}
                  {stock.pctChange}%
                </td>

                {/* Volume */}
                <td className="sm__td-num">
                  {stock.volume?.toLocaleString("en-IN")}
                </td>

                {/* Avg Volume 20d */}
                <td className="sm__td-num">
                  {stock.averageVolume20 > 0
                    ? stock.averageVolume20.toLocaleString("en-IN")
                    : "—"}
                </td>

                {/* Relative Volume (volume / avg_vol_20) */}
                <td
                  className={`sm__td-num ${getRvolClass(stock.relativeVolume)}`}
                >
                  {stock.relativeVolume !== null
                    ? `${stock.relativeVolume}x`
                    : "—"}
                </td>

                {/* RVOL from smart_money */}
                <td className={`sm__td-num ${getRvolClass(stock.rvolValue)}`}>
                  {stock.rvolValue !== null ? (
                    <span>
                      {stock.rvolValue}x{" "}
                      {/* <span className="sm__sub-signal">
                          {stock.rvolSignal}
                        </span> */}
                    </span>
                  ) : (
                    "—"
                  )}
                </td>

                {/* CMF */}
                <td
                  className={`sm__td-num ${getSignalTextClass(stock.cmfSignal)}`}
                >
                  {stock.cmfValue !== null ? (
                    <span>
                      {stock.cmfValue.toFixed(4)}{" "}
                      {/* <span className="sm__sub-signal">
                          {stock.cmfSignal}
                        </span> */}
                    </span>
                  ) : (
                    "—"
                  )}
                </td>

                {/* MFI */}
                <td
                  className={`sm__td-num ${getSignalTextClass(stock.mfiSignal)}`}
                >
                  {stock.mfiValue !== null ? (
                    <span>
                      {stock.mfiValue.toFixed(2)}{" "}
                      {/* <span className="sm__sub-signal">
                          {stock.mfiSignal}
                        </span> */}
                    </span>
                  ) : (
                    "—"
                  )}
                </td>

                {/* OBV */}
                <td
                  className={`sm__td-num ${getSignalTextClass(stock.obvSignal)}`}
                >
                  {stock.obvSignal}
                </td>
                <td className="sm__td-num">
                  <span>{stock?.macd}</span>
                </td>
                <td
                  //   className={`sm__td-num ${getSignalTextClass(stock.obvSignal)}`}
                  className={`sm__signal-pill ${getSignalTextClass(stock.macdSignal)}`}
                >
                  {stock?.macdSignal}
                </td>

                {/* VWAP Signal */}
                {/* <td
                    className={`sm__td-num ${getSignalTextClass(stock.vwapSignal)}`}
                  >
                    {stock.vwapSignal}
                  </td> */}

                {/* Smart Money Score */}
                <td className="sm__td-num">
                  {stock.smartMoneyScore !== null ? (
                    <span
                      className={`sm__signal-badge ${getScoreClass(stock.smartMoneyScore)}`}
                    >
                      {stock.smartMoneyScore}
                    </span>
                  ) : (
                    "—"
                  )}
                </td>

                {/* Smart Money Signal */}
                <td className="sm__td-num">
                  <span
                    className={`sm__signal-pill ${getSignalTextClass(stock.smartMoneySignal)}`}
                  >
                    {stock.smartMoneySignal}
                  </span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Footer */}
      {/* {sorted.length > 0 && (
        <div className="sm__footer">
          <span>
            Showing {sorted.length} of {allStocks.length} results
          </span>
        </div>
      )} */}
    </div>
  );
};

export default SmartMoneyScreener;
